<template>
  <div>
    <b-alert
      show
      :variant="variant"
      class="m-0 my-0 alert-sin-asignar border-none pl-2 pt-1 pb-1"
    >
      <div class="text-alert-modal" :v-if="icon">
        <img
          class="img-alert-modal mr-2 mb-1"
          src="@/assets/images/icons/close-circle-line.svg"
          width="15%"
        />
        <b>{{ text }}</b>
      </div>
    </b-alert>
  </div>
</template>
<script>
export default {
  name: "alert-sin-asignar",
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    text: {
      default: "",
      type: String,
    },
    variant: {
      default: "",
      type: String,
    },
    icon: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["click:emit"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.alert-sin-asignar {
  background: #fff1f0 !important;
  border-radius: 8px !important;
}
.text-alert-modal {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #ac0000;
}
</style>